import { useState, useEffect, Fragment, useMemo } from 'react'
import apiFetch from '@wordpress/api-fetch'
import Breadcrumb from './Breadcrumb.jsx'
import PageHeader from './PageHeader.jsx'
import ReactPaginate from 'react-paginate'
import getImageUrl from './get-image-url.js'
import PageMenu from './PageMenu.jsx'
import { format, set } from 'date-fns'
import { Icon } from '@iconify/react'
import 'animate.css'
import { useMediaQuery } from 'react-responsive'
import Pagination from 'rc-pagination'

import scrollIntoView from 'scroll-into-view-if-needed'
const scr = (node) => {
  scrollIntoView(node, {
    behavior: 'smooth',
    scrollMode: 'if-needed',
    block: 'start',
    inline: 'start',
  })
}

const site_url = import.meta.env.VITE_SITE_URL

const Thumb = ({ id }) => {
  const [media, setMedia] = useState(null)

  useEffect(() => {
    if (id) {
      apiFetch({
        path: `${site_url}/wp-json/wp/v2/media/${id}`,
      }).then((media) => {
        setMedia(media)
      })
    }
  }, [])

  return id ? (
    media ? (
      <img
        src={media.source_url}
        className="w-full aspect-[315/225] object-cover"
      />
    ) : (
      <div className="grid place-items-center p-3">
        <img
          src={getImageUrl('kowashiro1.webp')}
          alt=""
          className="w-full aspect-[315/225] h-full object-contain"
        />
      </div>
    )
  ) : (
    <div className="grid place-items-center p-3">
      <img
        src={getImageUrl('kowashiro1.webp')}
        alt=""
        className="w-full h-full aspect-[315/225] object-contain"
      />
    </div>
  )
}

function Content() {
  const [data, setData] = useState([])
  const [term, setTerm] = useState(null)
  const [categories, setCategories] = useState(null)
  const [count, setCount] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)

  const isPC = useMediaQuery({
    query: '(min-width: 1024px)',
  })

  function termFilter(id) {
    const url = new URL(window.location.href)
    const params = url.searchParams
    params.delete('cat')
    params.delete('page')
    history.replaceState('', '', url.pathname)

    if (id === term) {
      setTerm(null)
      sessionStorage.removeItem('post_category')
      sessionStorage.removeItem('post_page')
    } else {
      setTerm(id)
      setCurrentPage(1)
      sessionStorage.setItem('post_category', id)
    }
  }

  function Items({ currentItems }) {
    return (
      <>
        {currentItems &&
          currentItems.map((item) => {
            const cat = categories.find((cat) => cat.id === item.categories[0])

            return (
              <Fragment key={item.id}>
                <div className="flex flex-col">
                  <a href={item.link}>
                    <Thumb id={item.featured_media} />
                  </a>
                  <div className="flex justify-between items-center pt-2 pb-3">
                    <a
                      className="terms"
                      href="#"
                    >
                      {cat.name}
                    </a>
                    <div className="date">{format(new Date(item.date), 'yyyy.MM.dd')}</div>
                  </div>
                  <div className="pb-4">
                    <a href={item.link}>
                      <h3 className="title">{item.title.rendered}</h3>
                    </a>
                  </div>
                  <hr className="mt-auto" />
                </div>
                <style jsx>{`
                  .terms {
                    padding: 0 14px;
                    border: 2px solid #2964b6;
                    border-radius: 24px;
                    text-align: center;
                    font: normal normal normal 18px/34px Noto Sans JP;
                    color: #2964b6;
                  }
                  .hr {
                    border-top: 1px solid #707070;
                  }
                  .date {
                    font: normal normal 500 20px/48px Noto Sans JP;
                    letter-spacing: 1px;
                  }
                  .title {
                    font: normal normal normal 20px/26px Noto Sans JP;
                    letter-spacing: 0.6px;
                  }
                  @media (min-width: 1024px) {
                    .terms {
                      padding: 0 14px;
                      border: 2px solid #2964b6;
                      border-radius: 24px;
                      text-align: center;
                      font: normal normal normal 18px/34px Noto Sans JP;
                      color: #2964b6;
                    }
                    .hr {
                      border-top: 1px solid #707070;
                    }
                    .date {
                      font: normal normal 500 20px/48px Noto Sans JP;
                      letter-spacing: 1px;
                    }
                    .title {
                      font: normal normal normal 20px/26px Noto Sans JP;
                      letter-spacing: 0.6px;
                    }
                  }
                `}</style>
              </Fragment>
            )
          })}
      </>
    )
  }

  function PaginatedItems({ itemsPerPage }) {
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0)
    const items = count * itemsPerPage

    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage
    const currentItems = data
    const pageCount = Math.ceil(items / itemsPerPage)

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      sessionStorage.setItem('post_page', event)
      setCurrentPage(event)
      scr(document.getElementById('content'))
    }

    return (
      <>
        <div className="grid lg:grid-cols-3 gap-x-7 gap-y-12 mt-[60px] lg:mt-[70px]">
          <Items currentItems={currentItems} />
        </div>
        <Pagination
          className="construction-example-pagination mt-[152px]"
          total={items}
          defaultPageSize={isPC ? 15 : 3}
          onChange={handlePageClick}
          current={currentPage}
          locale={'ja_JP'}
        />
      </>
    )
  }

  function Category({ id, children }) {
    return (
      <>
        <li>
          <button
            className={`cat${id === Number(term) ? ' active' : ''}`}
            onClick={() => termFilter(id)}
          >
            {children}
          </button>
        </li>
        <style jsx>{`
          .cat {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 2px solid #2964b6;
            border-radius: 24px;
            color: #2964b6;
            height: 34px;
            padding: 0 14px;
          }
          .cat.active {
            background: #2964b6 0% 0% no-repeat padding-box;
            color: #ffffff;
          }
          @media (min-width: 1024px) {
            .cat {
              display: flex;
              justify-content: center;
              align-items: center;
              border: 2px solid #2964b6;
              border-radius: 24px;
              color: #2964b6;
              height: 34px;
              padding: 0 14px;
            }
          }
        `}</style>
      </>
    )
  }

  useEffect(() => {
    apiFetch({
      path: `${site_url}/wp-json/wp/v2/categories`,
    }).then((categories) => {
      setCategories(categories)
    })

    // urlパラメータを取得
    const url = new URL(window.location.href)
    const params = url.searchParams

    if (params.has('cat')) {
      const cat = params.get('cat')
      setTerm(cat)
      sessionStorage.removeItem('post_category')
    } else {
      if (sessionStorage.getItem('post_category')) {
        setTerm(sessionStorage.getItem('post_category'))
      }
    }

    if (params.has('page')) {
      const current_page = params.get('page')
      setCurrentPage(current_page)
      sessionStorage.removeItem('post_page')
    } else {
      if (sessionStorage.getItem('post_page')) {
        setCurrentPage(sessionStorage.getItem('post_page'))
      }
    }
  }, [])

  useEffect(() => {
    apiFetch({
      path: `${site_url}/wp-json/wp/v2/posts?per_page=${isPC ? 15 : 3}&page=${currentPage}${
        term ? '&categories=' + term : ''
      }`,
      parse: false,
    })
      .then((raw) => {
        const counts = raw.headers.get('x-wp-totalpages')
        setCount(counts)
        return raw.json()
      })
      .then((data) => {
        setData(data)
      })
  }, [term, currentPage])

  return (
    <>
      {isPC ? <PageMenu /> : ''}
      <PageHeader
        title="お知らせ一覧"
        image={getImageUrl('NEWS-LIST.png')}
      />
      <div
        id="content"
        className="content-area pt-8"
      >
        <Breadcrumb
          current="お知らせ一覧"
          site_url={site_url}
          items={[]}
        />
        <ul className="flex lg:gap-3 mt-6 flex-wrap gap-[min(calc(24vw/7.5),12px)] lg:flex-nowrap">
          {categories
            ? categories.map((item, index) => {
                return (
                  <Category
                    key={index}
                    id={item.id}
                  >
                    {item.name}
                  </Category>
                )
              })
            : ''}
        </ul>

        {data.length ? (
          <PaginatedItems itemsPerPage={isPC ? 15 : 3} />
        ) : (
          <div className="flex justify-center items-center">
            <Icon
              icon="mdi:loading"
              className="animate__animated animate__rotateOut animate__fast animate__infinite w-80 h-80"
            />
          </div>
        )}
      </div>
      <style jsx>{`
        h2 {
          font: normal normal bold 30px/58px Noto Sans JP;
        }
        .terms {
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2px solid #2964b6;
          border-radius: 24px;
          color: #2964b6;
          height: 34px;
          padding: 0 14px;
        }
        .terms.active {
          background: #2964b6 0% 0% no-repeat padding-box;
          color: #ffffff;
        }
        @media (min-width: 1024px) {
          h2 {
            font: normal normal bold 30px/58px Noto Sans JP;
          }
          .terms {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 2px solid #2964b6;
            border-radius: 24px;
            color: #2964b6;
            height: 34px;
            padding: 0 14px;
          }
          .terms.active {
            background: #2964b6 0% 0% no-repeat padding-box;
            color: #ffffff;
          }
        }
      `}</style>
    </>
  )
}

export default Content
